import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Injectable()
export class BrDateAdapter extends NativeDateAdapter {

  override getFirstDayOfWeek(): number {
    return 1; // Segunda-feira
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const long = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];

    return long;
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const long = [
      'domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'
    ];

    const narrow = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    return style === 'long' ? long : narrow;
  }

  override format(date: Date): string {
    const d = ('00' + date.getDate()).slice(-2);
    const m = ('00' + (date.getMonth() + 1)).slice(-2);
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }
}

@Injectable()
export class MatDatepickerIntlBr extends MatDatepickerIntl {
  override calendarLabel = 'Calendário';
  override openCalendarLabel = 'Abrir calendário';
  override prevMonthLabel = 'Mês anterior';
  override nextMonthLabel = 'Próximo mês';
  override prevYearLabel = 'Ano anterior';
  override nextYearLabel = 'Próximo ano';
  override switchToMonthViewLabel = 'Ver meses';
  override switchToMultiYearViewLabel = 'Ver anos';
}
